<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="所属项目">
              <a-input
                readOnly
                v-model="model.projectName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商名称">
              <a-input
                readOnly
                v-model="model.supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称">
              <a-input
                readOnly
                v-model="model.name"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同编号">
              <a-input
                readOnly
                v-model="model.number"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
              <a-input
                addon-after="元"
                readOnly
                v-model="model.contractAmount"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
              <a-input
                readOnly
                v-model="model.contactsName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input
                readOnly
                v-model="model.mobile"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
              <a-input
                readOnly
                v-model="model.email"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生效日期">
              <a-input
                readOnly
                v-model="model.effectiveDate"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到期日期">
              <a-input
                readOnly
                v-model="model.expirationDate"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人">
              <a-input
                readOnly
                v-model="model.operatorName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办日期">
              <a-input
                readOnly
                v-model="model.handleDate"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预付款">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.advanceCharge"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货款">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.paymentGoods"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到货款">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.arrivalCharge"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预验收款">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.preAcceptanceCharge"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="政府审计款">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.governmentAuditFund"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最终验收款">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.acceptanceCharge"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质保金">
              <a-input
                addon-after="%"
                readOnly
                v-model="model.warrantyGlod"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注">
              <a-textarea
                :rows="3"
                readOnly
                v-model="model.remark"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="上传附件">
              <div v-for="(item, index) in fileList" :key="index">
                <down-load :option="item"></down-load>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import downLoad from '@/CrComponents/DownLoad'
import DownLoadCard from '@/CrComponents/DownLoadCard/DownLoadCard.vue'
// import { addressOptions } from '@/utils/proviceData.js'
export default {
  name: 'ViewPurchase',
  mounted () {},
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal,
    downLoad,
    DownLoadCard
  },
  data () {
    return {
      fileList: [], // 默认上传文件
      title: '操作',
      width: 800,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'markets' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        if (this.model.files) {
          this.fileList = this.model.files.map(item => {
            item.url = `/opt/pms/back/dataSystem/contract/${item.filePath}`
            return item
          })
        }
      }
    },
    // 清空表单
    formClear () {
      this.fileList = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped lang="less">
.downloadList{
  margin-top: 10px;
  list-style: none;
  li{
    margin: 10px;
  }
}
</style>
